import { useState } from 'react';
import { TextStyled, Flex, StyledImg } from '../../component-library';
import card from '../../assets/img/card.png';
import { theme } from '../../2022-component-library';
import styled from '@emotion/styled';

const CalibrationCardPatient = ({ setActiveTab, postMessage }) => {
  const [cardWidth, setCardWidth] = useState(355);
  const [cardHeight, setCardHeight] = useState(222);

  const sendCardDimensions = (data, initial) => {
    const { currentWidth, currentHeight, screenWidth, screenHeight } = data;
    const isInitial = initial ? true : false;

    const cardDimensionsMessage = {
      type: 'cardDimensions',
      content: {
        cardWidthPx: currentWidth,
        cardHeightPx: currentHeight,
        screenWidthPx: screenWidth,
        screenHeightPx: screenHeight,
        initial: isInitial,
      },
    };
    postMessage(cardDimensionsMessage);
  };

  const decreaseCard = () => {
    const currentWidth = Math.round(cardWidth + cardWidth * -0.01);
    const currentHeight = Math.round(cardHeight + cardHeight * -0.01);
    setCardWidth(currentWidth);
    setCardHeight(currentHeight);
    const data = {
      currentWidth,
      currentHeight,
      screenWidth: window.screen.availWidth,
      screenHeight: window.screen.availHeight,
    };
    sendCardDimensions(data);
  };

  const increaseCard = () => {
    const currentWidth = Math.round(cardWidth + cardWidth * 0.01);
    const currentHeight = Math.round(cardHeight + cardHeight * 0.01);
    setCardWidth(currentWidth);
    setCardHeight(currentHeight);
    const data = {
      currentWidth,
      currentHeight,
      screenWidth: window.screen.availWidth,
      screenHeight: window.screen.availHeight,
    };
    sendCardDimensions(data);
  };

  const AdjustmentButton = styled(Flex)`
    border: 5px solid ${theme.colors.primary};
    border-radius: 50%;
    width: 60px;
    height: 60px;
    z-index: 86;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${theme.colors.primary};
    font-weight: bold;
    font-size: 2rem;
    padding-bottom: 0.25rem;
    cursor: pointer;
  `;

  return (
    <Flex alignItems='center' flexDirection='column'>
      <TextStyled m='20px 0 20px'>Screen Dimensions</TextStyled>
      <TextStyled mb='20px'>To ensure accurate test results we need to know your screen size.</TextStyled>
      <TextStyled fontWeight='bold'>Place a standard card (bank or ID) below and adjust the size to match your card.</TextStyled>
      <TextStyled m='20px 0 20px'>Use control buttons to adjust size</TextStyled>
      <Flex alignItems='center' mb='20px'>
        <AdjustmentButton onClick={() => decreaseCard()}>-</AdjustmentButton>
        <StyledImg src={card} alt='logo' width={`${cardWidth}px`} height={`${cardHeight}px`} m='0 20px 0' />
        <AdjustmentButton onClick={() => increaseCard()}>+</AdjustmentButton>
      </Flex>
    </Flex>
  );
};

export default CalibrationCardPatient;
